
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as _91id_931nu_v_45dMQdgW6K6cjH6dl5ris7vwiz_45ZmPASfF6Sj18Meta } from "/app/pages/tickets/[id].vue?macro=true";
import { default as indexBsN6Su4PrH0ZFwg_45BZmsDTptkkKqiXQdUAsgVVJJWZsMeta } from "/app/pages/courses/index.vue?macro=true";
import { default as index2er9ahYr3_45Om2KCtA_ASdhxLMV0035awBbxo_BhMgwsMeta } from "/app/pages/tickets/index.vue?macro=true";
import { default as index3kuksmm5bB32shg1XKa9_2VlNreoq3Jcbruv2vO4ZxMMeta } from "/app/pages/sessions/index.vue?macro=true";
import { default as createnidYcrtC5QyXWlMkIffNfknt1i5LsKkbQ4IIkC9HSGcMeta } from "/app/pages/tickets/create.vue?macro=true";
import { default as indexB8fT2V2iAv7pMMc87MUL8WxQ8C5oiOHXQ602ygqmisIMeta } from "/app/pages/questions/index.vue?macro=true";
import { default as index_5HwpLrspoiI5mMsZ2v7BiAd_455ZbC0fV3ovhMZA0zOEMeta } from "/app/pages/transactions/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "tickets-id",
    path: "/tickets/:id()",
    component: () => import("/app/pages/tickets/[id].vue")
  },
  {
    name: "courses",
    path: "/courses",
    component: () => import("/app/pages/courses/index.vue")
  },
  {
    name: "tickets",
    path: "/tickets",
    component: () => import("/app/pages/tickets/index.vue")
  },
  {
    name: "sessions",
    path: "/sessions",
    component: () => import("/app/pages/sessions/index.vue")
  },
  {
    name: "tickets-create",
    path: "/tickets/create",
    component: () => import("/app/pages/tickets/create.vue")
  },
  {
    name: "questions",
    path: "/questions",
    component: () => import("/app/pages/questions/index.vue")
  },
  {
    name: "transactions",
    path: "/transactions",
    component: () => import("/app/pages/transactions/index.vue")
  }
]